const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userInfo2: state => state.user.userInfo2,
  details: state => state.user.details
};
export default getters;
